import { enumBrand } from "../constants";

export function isMfeContext(): boolean {
  return typeof window !== "undefined" && (window as any).__OC_MFE_API_BASE__ !== undefined;
}

export function isIsolvedMfeContext(): boolean {
  return isMfeContext() && (window as any).__OC_MFE_BRAND__ === enumBrand.isolved;
}
